<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Application Form UI</title>
    <link rel="stylesheet" href="applicant-detail.component.scss" />
  </head>
  <body>
    <div class="main-container">
      <aside class="sidebar">
        <button (click)="viewApplicantList()" class="btn-back button-default custom-btn-secondary">
          <i class="fa-solid fa-chevron-left mr-10"></i>Back to Applicant List
        </button>
        <div class="profile">
          <img
            src="assets/images/user.png"
            alt="Profile"
            class="profile-picture"
          />
          <h3>
            {{ firstName }}
            {{ lastName }}
          </h3>
        </div>
        <div class="profile-details">
          <p>
            <strong>Phone:</strong>
            {{ phoneNo }}
          </p>
          <p><strong>Email:</strong> {{ emailAddress }}</p>
          <p><strong>Client Number:</strong> {{ clientNumber }}</p>
          <p>
            <strong>Home Address:</strong> {{ locationAddress }}
          </p>
          <p><strong>Birthday:</strong> {{ birthday | date: 'MM/dd/yyyy' }}</p>
        </div>
      </aside>

      <main class="content">
        <!-- Page main heading (visually hidden for screen readers) -->
        <h1 class="sr-only">Applicant Detail</h1>

        <!-- App Section grouped as <section> -->
        <section class="app-section" aria-labelledby="application-section">
          <h2 id="application-section" class="sr-only">Application Options</h2>

          <div class="application">
            <img src="assets/images/start-application.png" alt="Start New Application" width="100" height="100" />
            <h3>Start New Application</h3>
            <p>
              This process will guide you step-by-step to ensure all necessary information is gathered.
            </p>
            <button
              (click)="goToApplicationForm()"
              class="button-default custom-btn-primary mt-43"
              aria-label="Start Application"
            >
              Start Application
            </button>
          </div>
          <div class="application">
            <img src="assets/images/start-application.png" alt="Upload Paper Application" width="100" height="100" />
            <h3>Upload Paper Application</h3>
            <p>
              Upload a scanned form and we'll detect the fields automatically. Any missing or incorrect information will be highlighted for you to review.
            </p>
            <button class="upload-form custom-btn-primary button-default" disabled aria-label="Upload Form">Upload Form</button>
          </div>
        </section>

        <section class="case-details" aria-labelledby="case-details-heading">
          <div class="mat-elevation-z1" style="box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);" *ngIf="!isLoading">
            <app-eg-table
              *ngIf="!isLoading && applicationsCopy && applicationsCopy?.length > 0"
              [data]="applicationsCopy" [start]="start" [end]="end" [pageSize]="pageSize"
              [totalElements]="totalElements" [pageIndex]="pageIndex"
              [columns]="displayedColumns" [columnKeyValues]="cols" [serverSidePagination]="true"
              (pageEvent)="getChangedApplicationsList($event)" (btnClicked)="getCompletionStatus($event)"
              (renewalClicked)="onRenewalClicked($event)" (printRenewalClicked)="onPrintRenewalLetter($event)"
              [showSortIcon]="true"
            >
              <caption class="sr-only">List of case applications with pagination and actions</caption>
            </app-eg-table>
          </div>
          <div class="case-item" *ngIf="(!applications) || (applications?.length === 0 && !submittedApplicationId)">
            No applications found for this applicant.
          </div>
        </section>
      </main>
      <div class="overlay" *ngIf="isLoading"></div>
      <div class="spinner-border m4 loading-indicator" style="color: #2730E3;position: absolute;top: 50%;left: 50%;width: 3rem; height: 3rem;" role="status" *ngIf="isLoading">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </body>
</html>